// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AttorneysRouteImport } from './routes/attorneys'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BookRouteImport } from './routes/book'
import { Route as CareersRouteImport } from './routes/careers'
import { Route as CartRouteImport } from './routes/cart'
import { Route as CaseStudiesRouteImport } from './routes/case-studies'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as ComplaintsRouteImport } from './routes/complaints'
import { Route as ComplianceServicesRouteImport } from './routes/compliance-services'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ContractsRouteImport } from './routes/contracts'
import { Route as CorporateTrainingRouteImport } from './routes/corporate-training'
import { Route as CreditsRouteImport } from './routes/credits'
import { Route as CrimeAwarenessRouteImport } from './routes/crime-awareness'
import { Route as CvBuilderRouteImport } from './routes/cv-builder'
import { Route as CvServicesRouteImport } from './routes/cv-services'
import { Route as DailyLegalRouteImport } from './routes/daily-legal'
import { Route as DisclaimerRouteImport } from './routes/disclaimer'
import { Route as EducationRouteImport } from './routes/education'
import { Route as EftPendingRouteImport } from './routes/eft-pending'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as FoundingPartnersRouteImport } from './routes/founding-partners'
import { Route as GuidesRouteImport } from './routes/guides'
import { Route as LegislationRouteImport } from './routes/legislation'
import { Route as LexpractiqRouteImport } from './routes/lexpractiq'
import { Route as NewsRouteImport } from './routes/news'
import { Route as PopiaRouteImport } from './routes/popia'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as RadioRouteImport } from './routes/radio'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ResourcesRouteImport } from './routes/resources'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ToolsRouteImport } from './routes/tools'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as VerifyRouteImport } from './routes/verify'
import { Route as WritingAcademyRouteImport } from './routes/writing-academy'
import { Route as AuthenticatedPortalRouteImport } from './routes/_authenticated/portal'
import { Route as CareersIdRouteImport } from './routes/careers.$id'
import { Route as CareersUnsubscribeRouteImport } from './routes/careers.unsubscribe'
import { Route as ContractsSlugRouteImport } from './routes/contracts.$slug'
import { Route as DocumentServicesIndexRouteImport } from './routes/document-services.index'
import { Route as DocumentServicesServiceIdRouteImport } from './routes/document-services.$serviceId'
import { Route as EducationIndexRouteImport } from './routes/education.index'
import { Route as EducationCourtOnlineRouteImport } from './routes/education.court-online'
import { Route as EducationHighSchoolRouteImport } from './routes/education.high-school'
import { Route as EducationLegalArticleGuideRouteImport } from './routes/education.legal-article-guide'
import { Route as EducationLlbTutoringRouteImport } from './routes/education.llb-tutoring'
import { Route as EducationResearchRouteImport } from './routes/education.research'
import { Route as EducationWritingRouteImport } from './routes/education.writing'
import { Route as GuidesSlugRouteImport } from './routes/guides.$slug'
import { Route as InstallmentsRefRouteImport } from './routes/installments.$ref'
import { Route as InvoiceIndexRouteImport } from './routes/invoice.index'
import { Route as InvoiceIdRouteImport } from './routes/invoice.$id'
import { Route as InvoiceRefRouteImport } from './routes/invoice.$ref'
import { Route as LearnersJoinRouteImport } from './routes/learners.join'
import { Route as LegalHelpTopicRouteImport } from './routes/legal-help.$topic'
import { Route as LegislationSlugRouteImport } from './routes/legislation.$slug'
import { Route as LexpractiqIndexRouteImport } from './routes/lexpractiq.index'
import { Route as LexpractiqForEmployersRouteImport } from './routes/lexpractiq.for-employers'
import { Route as LexpractiqForUniversitiesRouteImport } from './routes/lexpractiq.for-universities'
import { Route as LexpractiqHowItWorksRouteImport } from './routes/lexpractiq.how-it-works'
import { Route as NewsSlugRouteImport } from './routes/news.$slug'
import { Route as OrderSuccessRefRouteImport } from './routes/order-success.$ref'
import { Route as PaymentStatusRefRouteImport } from './routes/payment-status.$ref'
import { Route as PresentationsIndexRouteImport } from './routes/presentations.index'
import { Route as PresentationsSlugRouteImport } from './routes/presentations.$slug'
import { Route as RadioSlugRouteImport } from './routes/radio.$slug'
import { Route as ResourcesIndexRouteImport } from './routes/resources.index'
import { Route as ResourcesSlugRouteImport } from './routes/resources.$slug'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as ServicesSlugRouteImport } from './routes/services.$slug'
import { Route as ServicesCompanySecretarialRouteImport } from './routes/services.company-secretarial'
import { Route as ToolsIndexRouteImport } from './routes/tools.index'
import { Route as ToolsHumaniserRouteImport } from './routes/tools.humaniser'
import { Route as ToolsOcrRouteImport } from './routes/tools.ocr'
import { Route as ToolsParaphraserRouteImport } from './routes/tools.paraphraser'
import { Route as ToolsPdfRouteImport } from './routes/tools.pdf'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'
import { Route as AuthenticatedLexpractiqDashboardRouteImport } from './routes/_authenticated/lexpractiq.dashboard'
import { Route as AuthenticatedLexpractiqMyAssessmentsRouteImport } from './routes/_authenticated/lexpractiq.my-assessments'
import { Route as AuthenticatedLexpractiqPortfolioEvidenceRouteImport } from './routes/_authenticated/lexpractiq.portfolio-evidence'
import { Route as AuthenticatedLexpractiqRecruiterRouteImport } from './routes/_authenticated/lexpractiq.recruiter'
import { Route as AuthenticatedLexpractiqUniversityRouteImport } from './routes/_authenticated/lexpractiq.university'
import { Route as AuthenticatedPortalIndexRouteImport } from './routes/_authenticated/portal.index'
import { Route as AuthenticatedPortalAcademyRouteImport } from './routes/_authenticated/portal.academy'
import { Route as AuthenticatedPortalAccountRouteImport } from './routes/_authenticated/portal.account'
import { Route as AuthenticatedPortalAdminRouteImport } from './routes/_authenticated/portal.admin'
import { Route as AuthenticatedPortalCertificatesRouteImport } from './routes/_authenticated/portal.certificates'
import { Route as AuthenticatedPortalChatRouteImport } from './routes/_authenticated/portal.chat'
import { Route as AuthenticatedPortalCreditsRouteImport } from './routes/_authenticated/portal.credits'
import { Route as AuthenticatedPortalCvRouteImport } from './routes/_authenticated/portal.cv'
import { Route as AuthenticatedPortalDashboardRouteImport } from './routes/_authenticated/portal.dashboard'
import { Route as AuthenticatedPortalDocumentsRouteImport } from './routes/_authenticated/portal.documents'
import { Route as AuthenticatedPortalInterviewRouteImport } from './routes/_authenticated/portal.interview'
import { Route as AuthenticatedPortalInvoicesRouteImport } from './routes/_authenticated/portal.invoices'
import { Route as AuthenticatedPortalJobMatchesRouteImport } from './routes/_authenticated/portal.job-matches'
import { Route as AuthenticatedPortalLabourAnalyzerRouteImport } from './routes/_authenticated/portal.labour-analyzer'
import { Route as AuthenticatedPortalLlbReceiptsRouteImport } from './routes/_authenticated/portal.llb-receipts'
import { Route as AuthenticatedPortalLlbTutoringRouteImport } from './routes/_authenticated/portal.llb-tutoring'
import { Route as AuthenticatedPortalMattersRouteImport } from './routes/_authenticated/portal.matters'
import { Route as AuthenticatedPortalMyCitationsRouteImport } from './routes/_authenticated/portal.my-citations'
import { Route as AuthenticatedPortalMyPaymentsRouteImport } from './routes/_authenticated/portal.my-payments'
import { Route as AuthenticatedPortalOrdersRouteImport } from './routes/_authenticated/portal.orders'
import { Route as AuthenticatedPortalProfileRouteImport } from './routes/_authenticated/portal.profile'
import { Route as AuthenticatedPortalStudentRouteImport } from './routes/_authenticated/portal.student'
import { Route as AuthenticatedPortalSubscriptionRouteImport } from './routes/_authenticated/portal.subscription'
import { Route as AuthenticatedPortalToolsDashboardRouteImport } from './routes/_authenticated/portal.tools-dashboard'
import { Route as CareersSubscribeConfirmRouteImport } from './routes/careers.subscribe.confirm'
import { Route as EducationResearchIndexRouteImport } from './routes/education.research.index'
import { Route as EducationResearchAssignmentRouteImport } from './routes/education.research.assignment'
import { Route as EducationResearchCaseAnalysisRouteImport } from './routes/education.research.case-analysis'
import { Route as EducationResearchFootnotesRouteImport } from './routes/education.research.footnotes'
import { Route as EducationResearchIracRouteImport } from './routes/education.research.irac'
import { Route as EducationResearchJudgmentSummaryRouteImport } from './routes/education.research.judgment-summary'
import { Route as EducationResearchSourcesRouteImport } from './routes/education.research.sources'
import { Route as EducationResearchTemplatesRouteImport } from './routes/education.research.templates'
import { Route as EducationResearchWorksheetRouteImport } from './routes/education.research.worksheet'
import { Route as EducationSkillsSlugRouteImport } from './routes/education.skills.$slug'
import { Route as EducationWritingIndexRouteImport } from './routes/education.writing.index'
import { Route as EducationWritingStyleRouteImport } from './routes/education.writing.$style'
import { Route as EducationWritingArticleEditorRouteImport } from './routes/education.writing.article-editor'
import { Route as EducationWritingBibliographyRouteImport } from './routes/education.writing.bibliography'
import { Route as EducationWritingTemplatesRouteImport } from './routes/education.writing.templates'
import { Route as EducationWritingToolsRouteImport } from './routes/education.writing.tools'
import { Route as LexpractiqPortfolioUserIdRouteImport } from './routes/lexpractiq.portfolio.$userId'
import { Route as LexpractiqSimulationsIndexRouteImport } from './routes/lexpractiq.simulations.index'
import { Route as LexpractiqSimulationsSlugRouteImport } from './routes/lexpractiq.simulations.$slug'
import { Route as LexpractiqVerifyTokenRouteImport } from './routes/lexpractiq.verify.$token'
import { Route as PayInvoiceRefRouteImport } from './routes/pay.invoice.$ref'
import { Route as TelegramLinkTokenRouteImport } from './routes/telegram.link.$token'
import { Route as AuthenticatedLexpractiqFirmsIndexRouteImport } from './routes/_authenticated/lexpractiq.firms.index'
import { Route as AuthenticatedLexpractiqFirmsFirmIdRouteImport } from './routes/_authenticated/lexpractiq.firms.$firmId'
import { Route as AuthenticatedLexpractiqMentorsIndexRouteImport } from './routes/_authenticated/lexpractiq.mentors.index'
import { Route as AuthenticatedLexpractiqMentorsApplyRouteImport } from './routes/_authenticated/lexpractiq.mentors.apply'
import { Route as AuthenticatedLexpractiqMentorsQAndARouteImport } from './routes/_authenticated/lexpractiq.mentors.q-and-a'
import { Route as AuthenticatedLexpractiqMentorsSessionsRouteImport } from './routes/_authenticated/lexpractiq.mentors.sessions'
import { Route as AuthenticatedLexpractiqRecruiterAssessmentsRouteImport } from './routes/_authenticated/lexpractiq.recruiter.assessments'
import { Route as AuthenticatedPortalAcademyIndexRouteImport } from './routes/_authenticated/portal.academy.index'
import { Route as AuthenticatedPortalAcademySlugRouteImport } from './routes/_authenticated/portal.academy.$slug'
import { Route as AuthenticatedPortalAdminAcademyRouteImport } from './routes/_authenticated/portal.admin.academy'
import { Route as AuthenticatedPortalAdminAcademyAiBuilderRouteImport } from './routes/_authenticated/portal.admin.academy-ai-builder'
import { Route as AuthenticatedPortalAdminAcademyQaRouteImport } from './routes/_authenticated/portal.admin.academy-qa'
import { Route as AuthenticatedPortalAdminAccountingRouteImport } from './routes/_authenticated/portal.admin.accounting'
import { Route as AuthenticatedPortalAdminAdsStudioRouteImport } from './routes/_authenticated/portal.admin.ads-studio'
import { Route as AuthenticatedPortalAdminAiAssistantRouteImport } from './routes/_authenticated/portal.admin.ai-assistant'
import { Route as AuthenticatedPortalAdminAiStatusRouteImport } from './routes/_authenticated/portal.admin.ai-status'
import { Route as AuthenticatedPortalAdminAllOrdersRouteImport } from './routes/_authenticated/portal.admin.all-orders'
import { Route as AuthenticatedPortalAdminAwarenessRouteImport } from './routes/_authenticated/portal.admin.awareness'
import { Route as AuthenticatedPortalAdminBookingsRouteImport } from './routes/_authenticated/portal.admin.bookings'
import { Route as AuthenticatedPortalAdminBrandInstallmentsRouteImport } from './routes/_authenticated/portal.admin.brand-installments'
import { Route as AuthenticatedPortalAdminCanvaStudioRouteImport } from './routes/_authenticated/portal.admin.canva-studio'
import { Route as AuthenticatedPortalAdminCareersRouteImport } from './routes/_authenticated/portal.admin.careers'
import { Route as AuthenticatedPortalAdminCertificatesRouteImport } from './routes/_authenticated/portal.admin.certificates'
import { Route as AuthenticatedPortalAdminClientBrandsRouteImport } from './routes/_authenticated/portal.admin.client-brands'
import { Route as AuthenticatedPortalAdminClientCreditsRouteImport } from './routes/_authenticated/portal.admin.client-credits'
import { Route as AuthenticatedPortalAdminClientsRouteImport } from './routes/_authenticated/portal.admin.clients'
import { Route as AuthenticatedPortalAdminCompanyAssetsRouteImport } from './routes/_authenticated/portal.admin.company-assets'
import { Route as AuthenticatedPortalAdminComposeEmailRouteImport } from './routes/_authenticated/portal.admin.compose-email'
import { Route as AuthenticatedPortalAdminContractOrdersRouteImport } from './routes/_authenticated/portal.admin.contract-orders'
import { Route as AuthenticatedPortalAdminCosecQuotesRouteImport } from './routes/_authenticated/portal.admin.cosec-quotes'
import { Route as AuthenticatedPortalAdminCreditOrdersRouteImport } from './routes/_authenticated/portal.admin.credit-orders'
import { Route as AuthenticatedPortalAdminCreditOrdersAuditRouteImport } from './routes/_authenticated/portal.admin.credit-orders-audit'
import { Route as AuthenticatedPortalAdminCreditReconciliationRouteImport } from './routes/_authenticated/portal.admin.credit-reconciliation'
import { Route as AuthenticatedPortalAdminCvRouteImport } from './routes/_authenticated/portal.admin.cv'
import { Route as AuthenticatedPortalAdminCvChecklistsRouteImport } from './routes/_authenticated/portal.admin.cv-checklists'
import { Route as AuthenticatedPortalAdminCvOrdersRouteImport } from './routes/_authenticated/portal.admin.cv-orders'
import { Route as AuthenticatedPortalAdminDiagnosticsRouteImport } from './routes/_authenticated/portal.admin.diagnostics'
import { Route as AuthenticatedPortalAdminDocumentsRouteImport } from './routes/_authenticated/portal.admin.documents'
import { Route as AuthenticatedPortalAdminEnquiriesRouteImport } from './routes/_authenticated/portal.admin.enquiries'
import { Route as AuthenticatedPortalAdminInboxRouteImport } from './routes/_authenticated/portal.admin.inbox'
import { Route as AuthenticatedPortalAdminInvoiceEmailsRouteImport } from './routes/_authenticated/portal.admin.invoice-emails'
import { Route as AuthenticatedPortalAdminInvoiceReconciliationRouteImport } from './routes/_authenticated/portal.admin.invoice-reconciliation'
import { Route as AuthenticatedPortalAdminInvoiceReminderRunsRouteImport } from './routes/_authenticated/portal.admin.invoice-reminder-runs'
import { Route as AuthenticatedPortalAdminInvoiceRemindersRouteImport } from './routes/_authenticated/portal.admin.invoice-reminders'
import { Route as AuthenticatedPortalAdminLabourAnalysesRouteImport } from './routes/_authenticated/portal.admin.labour-analyses'
import { Route as AuthenticatedPortalAdminLabourAnalysesAuditRouteImport } from './routes/_authenticated/portal.admin.labour-analyses-audit'
import { Route as AuthenticatedPortalAdminLabourTemplatesRouteImport } from './routes/_authenticated/portal.admin.labour-templates'
import { Route as AuthenticatedPortalAdminLegalUpdatesRouteImport } from './routes/_authenticated/portal.admin.legal-updates'
import { Route as AuthenticatedPortalAdminLibraryRouteImport } from './routes/_authenticated/portal.admin.library'
import { Route as AuthenticatedPortalAdminLinkedinStudioRouteImport } from './routes/_authenticated/portal.admin.linkedin-studio'
import { Route as AuthenticatedPortalAdminLlbEmailLogsRouteImport } from './routes/_authenticated/portal.admin.llb-email-logs'
import { Route as AuthenticatedPortalAdminLlbModulesRouteImport } from './routes/_authenticated/portal.admin.llb-modules'
import { Route as AuthenticatedPortalAdminLlbNotesCacheRouteImport } from './routes/_authenticated/portal.admin.llb-notes-cache'
import { Route as AuthenticatedPortalAdminLlbStoryVideosRouteImport } from './routes/_authenticated/portal.admin.llb-story-videos'
import { Route as AuthenticatedPortalAdminLlbTailoredNotesRouteImport } from './routes/_authenticated/portal.admin.llb-tailored-notes'
import { Route as AuthenticatedPortalAdminLlbTutoringRouteImport } from './routes/_authenticated/portal.admin.llb-tutoring'
import { Route as AuthenticatedPortalAdminManualInvoicesRouteImport } from './routes/_authenticated/portal.admin.manual-invoices'
import { Route as AuthenticatedPortalAdminNewsRouteImport } from './routes/_authenticated/portal.admin.news'
import { Route as AuthenticatedPortalAdminOutreachRouteImport } from './routes/_authenticated/portal.admin.outreach'
import { Route as AuthenticatedPortalAdminPayfastInvoiceLogRouteImport } from './routes/_authenticated/portal.admin.payfast-invoice-log'
import { Route as AuthenticatedPortalAdminPayfastItnRouteImport } from './routes/_authenticated/portal.admin.payfast-itn'
import { Route as AuthenticatedPortalAdminPayfastWebhookRouteImport } from './routes/_authenticated/portal.admin.payfast-webhook'
import { Route as AuthenticatedPortalAdminPaymentEventsRouteImport } from './routes/_authenticated/portal.admin.payment-events'
import { Route as AuthenticatedPortalAdminPaymentsMonitorRouteImport } from './routes/_authenticated/portal.admin.payments-monitor'
import { Route as AuthenticatedPortalAdminPresentationsRouteImport } from './routes/_authenticated/portal.admin.presentations'
import { Route as AuthenticatedPortalAdminProspectingRouteImport } from './routes/_authenticated/portal.admin.prospecting'
import { Route as AuthenticatedPortalAdminProspectiveLearnersRouteImport } from './routes/_authenticated/portal.admin.prospective-learners'
import { Route as AuthenticatedPortalAdminRadioRouteImport } from './routes/_authenticated/portal.admin.radio'
import { Route as AuthenticatedPortalAdminReceiptsQueueRouteImport } from './routes/_authenticated/portal.admin.receipts-queue'
import { Route as AuthenticatedPortalAdminResearchRouteImport } from './routes/_authenticated/portal.admin.research'
import { Route as AuthenticatedPortalAdminRssSourcesRouteImport } from './routes/_authenticated/portal.admin.rss-sources'
import { Route as AuthenticatedPortalAdminSecurityRouteImport } from './routes/_authenticated/portal.admin.security'
import { Route as AuthenticatedPortalAdminSecurityAlertsRouteImport } from './routes/_authenticated/portal.admin.security-alerts'
import { Route as AuthenticatedPortalAdminSentEmailsRouteImport } from './routes/_authenticated/portal.admin.sent-emails'
import { Route as AuthenticatedPortalAdminShareAttemptsRouteImport } from './routes/_authenticated/portal.admin.share-attempts'
import { Route as AuthenticatedPortalAdminSocialAnalyticsRouteImport } from './routes/_authenticated/portal.admin.social-analytics'
import { Route as AuthenticatedPortalAdminSocialQueueRouteImport } from './routes/_authenticated/portal.admin.social-queue'
import { Route as AuthenticatedPortalAdminSubscriptionsRouteImport } from './routes/_authenticated/portal.admin.subscriptions'
import { Route as AuthenticatedPortalAdminSupportTicketsRouteImport } from './routes/_authenticated/portal.admin.support-tickets'
import { Route as AuthenticatedPortalAdminTelegramRouteImport } from './routes/_authenticated/portal.admin.telegram'
import { Route as AuthenticatedPortalAdminUsersRouteImport } from './routes/_authenticated/portal.admin.users'
import { Route as AuthenticatedPortalAdminVacancySourcesRouteImport } from './routes/_authenticated/portal.admin.vacancy-sources'
import { Route as AuthenticatedPortalAdminWritingAcademyRouteImport } from './routes/_authenticated/portal.admin.writing-academy'
import { Route as AuthenticatedPortalLabourAnalyzerIdRouteImport } from './routes/_authenticated/portal.labour-analyzer.$id'
import { Route as AuthenticatedPortalStudentIndexRouteImport } from './routes/_authenticated/portal.student.index'
import { Route as AuthenticatedPortalStudentAssignmentsRouteImport } from './routes/_authenticated/portal.student.assignments'
import { Route as AuthenticatedPortalStudentPortfolioRouteImport } from './routes/_authenticated/portal.student.portfolio'
import { Route as AuthenticatedPortalStudentProfileRouteImport } from './routes/_authenticated/portal.student.profile'
import { Route as AuthenticatedPortalStudentWorkspaceRouteImport } from './routes/_authenticated/portal.student.workspace'
import { Route as AuthenticatedPortalWritingAcademySlugRouteImport } from './routes/_authenticated/portal.writing-academy.$slug'
import { Route as ContractsSlugOrderTokenRouteImport } from './routes/contracts.$slug.order.$token'
import { Route as AuthenticatedLexpractiqFirmsFirmIdDashboardRouteImport } from './routes/_authenticated/lexpractiq.firms.$firmId.dashboard'
import { Route as AuthenticatedLexpractiqFirmsAssignmentIdRouteImport } from './routes/_authenticated/lexpractiq.firms.assignment.$id'
import { Route as AuthenticatedLexpractiqSimulationsSlugRunRouteImport } from './routes/_authenticated/lexpractiq.simulations.$slug.run'
import { Route as AuthenticatedPortalAdminCasesIndexRouteImport } from './routes/_authenticated/portal.admin.cases.index'
import { Route as AuthenticatedPortalAdminCasesIdRouteImport } from './routes/_authenticated/portal.admin.cases.$id'
import { Route as AuthenticatedPortalAdminCasesNewRouteImport } from './routes/_authenticated/portal.admin.cases.new'
import { Route as AuthenticatedPortalAdminCasesReportsRouteImport } from './routes/_authenticated/portal.admin.cases.reports'
import { Route as AuthenticatedPortalAdminLabourAnalysesIdRouteImport } from './routes/_authenticated/portal.admin.labour-analyses.$id'
import { Route as AuthenticatedPortalAdminLabourTemplatesIdRouteImport } from './routes/_authenticated/portal.admin.labour-templates.$id'
import { Route as AuthenticatedPortalAdminLabourTemplatesNewRouteImport } from './routes/_authenticated/portal.admin.labour-templates.new'
import { Route as AuthenticatedPortalAdminManualInvoicesIdRouteImport } from './routes/_authenticated/portal.admin.manual-invoices.$id'
import { Route as AuthenticatedPortalLabourAnalyzerIdForm711RouteImport } from './routes/_authenticated/portal.labour-analyzer.$id.form-7-11'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AttorneysRoute = AttorneysRouteImport.update({
            id: '/attorneys',path: '/attorneys',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BookRoute = BookRouteImport.update({
            id: '/book',path: '/book',getParentRoute: () => rootRouteImport
          })
const CareersRoute = CareersRouteImport.update({
            id: '/careers',path: '/careers',getParentRoute: () => rootRouteImport
          })
const CartRoute = CartRouteImport.update({
            id: '/cart',path: '/cart',getParentRoute: () => rootRouteImport
          })
const CaseStudiesRoute = CaseStudiesRouteImport.update({
            id: '/case-studies',path: '/case-studies',getParentRoute: () => rootRouteImport
          })
const CheckoutRoute = CheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => rootRouteImport
          })
const ComplaintsRoute = ComplaintsRouteImport.update({
            id: '/complaints',path: '/complaints',getParentRoute: () => rootRouteImport
          })
const ComplianceServicesRoute = ComplianceServicesRouteImport.update({
            id: '/compliance-services',path: '/compliance-services',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ContractsRoute = ContractsRouteImport.update({
            id: '/contracts',path: '/contracts',getParentRoute: () => rootRouteImport
          })
const CorporateTrainingRoute = CorporateTrainingRouteImport.update({
            id: '/corporate-training',path: '/corporate-training',getParentRoute: () => rootRouteImport
          })
const CreditsRoute = CreditsRouteImport.update({
            id: '/credits',path: '/credits',getParentRoute: () => rootRouteImport
          })
const CrimeAwarenessRoute = CrimeAwarenessRouteImport.update({
            id: '/crime-awareness',path: '/crime-awareness',getParentRoute: () => rootRouteImport
          })
const CvBuilderRoute = CvBuilderRouteImport.update({
            id: '/cv-builder',path: '/cv-builder',getParentRoute: () => rootRouteImport
          })
const CvServicesRoute = CvServicesRouteImport.update({
            id: '/cv-services',path: '/cv-services',getParentRoute: () => rootRouteImport
          })
const DailyLegalRoute = DailyLegalRouteImport.update({
            id: '/daily-legal',path: '/daily-legal',getParentRoute: () => rootRouteImport
          })
const DisclaimerRoute = DisclaimerRouteImport.update({
            id: '/disclaimer',path: '/disclaimer',getParentRoute: () => rootRouteImport
          })
const EducationRoute = EducationRouteImport.update({
            id: '/education',path: '/education',getParentRoute: () => rootRouteImport
          })
const EftPendingRoute = EftPendingRouteImport.update({
            id: '/eft-pending',path: '/eft-pending',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const FoundingPartnersRoute = FoundingPartnersRouteImport.update({
            id: '/founding-partners',path: '/founding-partners',getParentRoute: () => rootRouteImport
          })
const GuidesRoute = GuidesRouteImport.update({
            id: '/guides',path: '/guides',getParentRoute: () => rootRouteImport
          })
const LegislationRoute = LegislationRouteImport.update({
            id: '/legislation',path: '/legislation',getParentRoute: () => rootRouteImport
          })
const LexpractiqRoute = LexpractiqRouteImport.update({
            id: '/lexpractiq',path: '/lexpractiq',getParentRoute: () => rootRouteImport
          })
const NewsRoute = NewsRouteImport.update({
            id: '/news',path: '/news',getParentRoute: () => rootRouteImport
          })
const PopiaRoute = PopiaRouteImport.update({
            id: '/popia',path: '/popia',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const RadioRoute = RadioRouteImport.update({
            id: '/radio',path: '/radio',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const ResourcesRoute = ResourcesRouteImport.update({
            id: '/resources',path: '/resources',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ToolsRoute = ToolsRouteImport.update({
            id: '/tools',path: '/tools',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const VerifyRoute = VerifyRouteImport.update({
            id: '/verify',path: '/verify',getParentRoute: () => rootRouteImport
          })
const WritingAcademyRoute = WritingAcademyRouteImport.update({
            id: '/writing-academy',path: '/writing-academy',getParentRoute: () => rootRouteImport
          })
const AuthenticatedPortalRoute = AuthenticatedPortalRouteImport.update({
            id: '/portal',path: '/portal',getParentRoute: () => AuthenticatedRouteRoute
          })
const CareersIdRoute = CareersIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => CareersRoute
          })
const CareersUnsubscribeRoute = CareersUnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => CareersRoute
          })
const ContractsSlugRoute = ContractsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ContractsRoute
          })
const DocumentServicesIndexRoute = DocumentServicesIndexRouteImport.update({
            id: '/document-services/',path: '/document-services/',getParentRoute: () => rootRouteImport
          })
const DocumentServicesServiceIdRoute = DocumentServicesServiceIdRouteImport.update({
            id: '/document-services/$serviceId',path: '/document-services/$serviceId',getParentRoute: () => rootRouteImport
          })
const EducationIndexRoute = EducationIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EducationRoute
          })
const EducationCourtOnlineRoute = EducationCourtOnlineRouteImport.update({
            id: '/court-online',path: '/court-online',getParentRoute: () => EducationRoute
          })
const EducationHighSchoolRoute = EducationHighSchoolRouteImport.update({
            id: '/high-school',path: '/high-school',getParentRoute: () => EducationRoute
          })
const EducationLegalArticleGuideRoute = EducationLegalArticleGuideRouteImport.update({
            id: '/legal-article-guide',path: '/legal-article-guide',getParentRoute: () => EducationRoute
          })
const EducationLlbTutoringRoute = EducationLlbTutoringRouteImport.update({
            id: '/llb-tutoring',path: '/llb-tutoring',getParentRoute: () => EducationRoute
          })
const EducationResearchRoute = EducationResearchRouteImport.update({
            id: '/research',path: '/research',getParentRoute: () => EducationRoute
          })
const EducationWritingRoute = EducationWritingRouteImport.update({
            id: '/writing',path: '/writing',getParentRoute: () => EducationRoute
          })
const GuidesSlugRoute = GuidesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => GuidesRoute
          })
const InstallmentsRefRoute = InstallmentsRefRouteImport.update({
            id: '/installments/$ref',path: '/installments/$ref',getParentRoute: () => rootRouteImport
          })
const InvoiceIndexRoute = InvoiceIndexRouteImport.update({
            id: '/invoice/',path: '/invoice/',getParentRoute: () => rootRouteImport
          })
const InvoiceIdRoute = InvoiceIdRouteImport.update({
            id: '/invoice/$id',path: '/invoice/$id',getParentRoute: () => rootRouteImport
          })
const InvoiceRefRoute = InvoiceRefRouteImport.update({
            id: '/invoice/$ref',path: '/invoice/$ref',getParentRoute: () => rootRouteImport
          })
const LearnersJoinRoute = LearnersJoinRouteImport.update({
            id: '/learners/join',path: '/learners/join',getParentRoute: () => rootRouteImport
          })
const LegalHelpTopicRoute = LegalHelpTopicRouteImport.update({
            id: '/legal-help/$topic',path: '/legal-help/$topic',getParentRoute: () => rootRouteImport
          })
const LegislationSlugRoute = LegislationSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => LegislationRoute
          })
const LexpractiqIndexRoute = LexpractiqIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LexpractiqRoute
          })
const LexpractiqForEmployersRoute = LexpractiqForEmployersRouteImport.update({
            id: '/for-employers',path: '/for-employers',getParentRoute: () => LexpractiqRoute
          })
const LexpractiqForUniversitiesRoute = LexpractiqForUniversitiesRouteImport.update({
            id: '/for-universities',path: '/for-universities',getParentRoute: () => LexpractiqRoute
          })
const LexpractiqHowItWorksRoute = LexpractiqHowItWorksRouteImport.update({
            id: '/how-it-works',path: '/how-it-works',getParentRoute: () => LexpractiqRoute
          })
const NewsSlugRoute = NewsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => NewsRoute
          })
const OrderSuccessRefRoute = OrderSuccessRefRouteImport.update({
            id: '/order-success/$ref',path: '/order-success/$ref',getParentRoute: () => rootRouteImport
          })
const PaymentStatusRefRoute = PaymentStatusRefRouteImport.update({
            id: '/payment-status/$ref',path: '/payment-status/$ref',getParentRoute: () => rootRouteImport
          })
const PresentationsIndexRoute = PresentationsIndexRouteImport.update({
            id: '/presentations/',path: '/presentations/',getParentRoute: () => rootRouteImport
          })
const PresentationsSlugRoute = PresentationsSlugRouteImport.update({
            id: '/presentations/$slug',path: '/presentations/$slug',getParentRoute: () => rootRouteImport
          })
const RadioSlugRoute = RadioSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => RadioRoute
          })
const ResourcesIndexRoute = ResourcesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ResourcesRoute
          })
const ResourcesSlugRoute = ResourcesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ResourcesRoute
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesRoute
          })
const ServicesSlugRoute = ServicesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ServicesRoute
          })
const ServicesCompanySecretarialRoute = ServicesCompanySecretarialRouteImport.update({
            id: '/company-secretarial',path: '/company-secretarial',getParentRoute: () => ServicesRoute
          })
const ToolsIndexRoute = ToolsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ToolsRoute
          })
const ToolsHumaniserRoute = ToolsHumaniserRouteImport.update({
            id: '/humaniser',path: '/humaniser',getParentRoute: () => ToolsRoute
          })
const ToolsOcrRoute = ToolsOcrRouteImport.update({
            id: '/ocr',path: '/ocr',getParentRoute: () => ToolsRoute
          })
const ToolsParaphraserRoute = ToolsParaphraserRouteImport.update({
            id: '/paraphraser',path: '/paraphraser',getParentRoute: () => ToolsRoute
          })
const ToolsPdfRoute = ToolsPdfRouteImport.update({
            id: '/pdf',path: '/pdf',getParentRoute: () => ToolsRoute
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })
const AuthenticatedLexpractiqDashboardRoute = AuthenticatedLexpractiqDashboardRouteImport.update({
            id: '/lexpractiq/dashboard',path: '/lexpractiq/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedLexpractiqMyAssessmentsRoute = AuthenticatedLexpractiqMyAssessmentsRouteImport.update({
            id: '/lexpractiq/my-assessments',path: '/lexpractiq/my-assessments',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedLexpractiqPortfolioEvidenceRoute = AuthenticatedLexpractiqPortfolioEvidenceRouteImport.update({
            id: '/lexpractiq/portfolio-evidence',path: '/lexpractiq/portfolio-evidence',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedLexpractiqRecruiterRoute = AuthenticatedLexpractiqRecruiterRouteImport.update({
            id: '/lexpractiq/recruiter',path: '/lexpractiq/recruiter',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedLexpractiqUniversityRoute = AuthenticatedLexpractiqUniversityRouteImport.update({
            id: '/lexpractiq/university',path: '/lexpractiq/university',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPortalIndexRoute = AuthenticatedPortalIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalAcademyRoute = AuthenticatedPortalAcademyRouteImport.update({
            id: '/academy',path: '/academy',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalAccountRoute = AuthenticatedPortalAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalAdminRoute = AuthenticatedPortalAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalCertificatesRoute = AuthenticatedPortalCertificatesRouteImport.update({
            id: '/certificates',path: '/certificates',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalChatRoute = AuthenticatedPortalChatRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalCreditsRoute = AuthenticatedPortalCreditsRouteImport.update({
            id: '/credits',path: '/credits',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalCvRoute = AuthenticatedPortalCvRouteImport.update({
            id: '/cv',path: '/cv',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalDashboardRoute = AuthenticatedPortalDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalDocumentsRoute = AuthenticatedPortalDocumentsRouteImport.update({
            id: '/documents',path: '/documents',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalInterviewRoute = AuthenticatedPortalInterviewRouteImport.update({
            id: '/interview',path: '/interview',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalInvoicesRoute = AuthenticatedPortalInvoicesRouteImport.update({
            id: '/invoices',path: '/invoices',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalJobMatchesRoute = AuthenticatedPortalJobMatchesRouteImport.update({
            id: '/job-matches',path: '/job-matches',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalLabourAnalyzerRoute = AuthenticatedPortalLabourAnalyzerRouteImport.update({
            id: '/labour-analyzer',path: '/labour-analyzer',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalLlbReceiptsRoute = AuthenticatedPortalLlbReceiptsRouteImport.update({
            id: '/llb-receipts',path: '/llb-receipts',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalLlbTutoringRoute = AuthenticatedPortalLlbTutoringRouteImport.update({
            id: '/llb-tutoring',path: '/llb-tutoring',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalMattersRoute = AuthenticatedPortalMattersRouteImport.update({
            id: '/matters',path: '/matters',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalMyCitationsRoute = AuthenticatedPortalMyCitationsRouteImport.update({
            id: '/my-citations',path: '/my-citations',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalMyPaymentsRoute = AuthenticatedPortalMyPaymentsRouteImport.update({
            id: '/my-payments',path: '/my-payments',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalOrdersRoute = AuthenticatedPortalOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalProfileRoute = AuthenticatedPortalProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalStudentRoute = AuthenticatedPortalStudentRouteImport.update({
            id: '/student',path: '/student',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalSubscriptionRoute = AuthenticatedPortalSubscriptionRouteImport.update({
            id: '/subscription',path: '/subscription',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalToolsDashboardRoute = AuthenticatedPortalToolsDashboardRouteImport.update({
            id: '/tools-dashboard',path: '/tools-dashboard',getParentRoute: () => AuthenticatedPortalRoute
          })
const CareersSubscribeConfirmRoute = CareersSubscribeConfirmRouteImport.update({
            id: '/subscribe/confirm',path: '/subscribe/confirm',getParentRoute: () => CareersRoute
          })
const EducationResearchIndexRoute = EducationResearchIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EducationResearchRoute
          })
const EducationResearchAssignmentRoute = EducationResearchAssignmentRouteImport.update({
            id: '/assignment',path: '/assignment',getParentRoute: () => EducationResearchRoute
          })
const EducationResearchCaseAnalysisRoute = EducationResearchCaseAnalysisRouteImport.update({
            id: '/case-analysis',path: '/case-analysis',getParentRoute: () => EducationResearchRoute
          })
const EducationResearchFootnotesRoute = EducationResearchFootnotesRouteImport.update({
            id: '/footnotes',path: '/footnotes',getParentRoute: () => EducationResearchRoute
          })
const EducationResearchIracRoute = EducationResearchIracRouteImport.update({
            id: '/irac',path: '/irac',getParentRoute: () => EducationResearchRoute
          })
const EducationResearchJudgmentSummaryRoute = EducationResearchJudgmentSummaryRouteImport.update({
            id: '/judgment-summary',path: '/judgment-summary',getParentRoute: () => EducationResearchRoute
          })
const EducationResearchSourcesRoute = EducationResearchSourcesRouteImport.update({
            id: '/sources',path: '/sources',getParentRoute: () => EducationResearchRoute
          })
const EducationResearchTemplatesRoute = EducationResearchTemplatesRouteImport.update({
            id: '/templates',path: '/templates',getParentRoute: () => EducationResearchRoute
          })
const EducationResearchWorksheetRoute = EducationResearchWorksheetRouteImport.update({
            id: '/worksheet',path: '/worksheet',getParentRoute: () => EducationResearchRoute
          })
const EducationSkillsSlugRoute = EducationSkillsSlugRouteImport.update({
            id: '/skills/$slug',path: '/skills/$slug',getParentRoute: () => EducationRoute
          })
const EducationWritingIndexRoute = EducationWritingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EducationWritingRoute
          })
const EducationWritingStyleRoute = EducationWritingStyleRouteImport.update({
            id: '/$style',path: '/$style',getParentRoute: () => EducationWritingRoute
          })
const EducationWritingArticleEditorRoute = EducationWritingArticleEditorRouteImport.update({
            id: '/article-editor',path: '/article-editor',getParentRoute: () => EducationWritingRoute
          })
const EducationWritingBibliographyRoute = EducationWritingBibliographyRouteImport.update({
            id: '/bibliography',path: '/bibliography',getParentRoute: () => EducationWritingRoute
          })
const EducationWritingTemplatesRoute = EducationWritingTemplatesRouteImport.update({
            id: '/templates',path: '/templates',getParentRoute: () => EducationWritingRoute
          })
const EducationWritingToolsRoute = EducationWritingToolsRouteImport.update({
            id: '/tools',path: '/tools',getParentRoute: () => EducationWritingRoute
          })
const LexpractiqPortfolioUserIdRoute = LexpractiqPortfolioUserIdRouteImport.update({
            id: '/portfolio/$userId',path: '/portfolio/$userId',getParentRoute: () => LexpractiqRoute
          })
const LexpractiqSimulationsIndexRoute = LexpractiqSimulationsIndexRouteImport.update({
            id: '/simulations/',path: '/simulations/',getParentRoute: () => LexpractiqRoute
          })
const LexpractiqSimulationsSlugRoute = LexpractiqSimulationsSlugRouteImport.update({
            id: '/simulations/$slug',path: '/simulations/$slug',getParentRoute: () => LexpractiqRoute
          })
const LexpractiqVerifyTokenRoute = LexpractiqVerifyTokenRouteImport.update({
            id: '/verify/$token',path: '/verify/$token',getParentRoute: () => LexpractiqRoute
          })
const PayInvoiceRefRoute = PayInvoiceRefRouteImport.update({
            id: '/pay/invoice/$ref',path: '/pay/invoice/$ref',getParentRoute: () => rootRouteImport
          })
const TelegramLinkTokenRoute = TelegramLinkTokenRouteImport.update({
            id: '/telegram/link/$token',path: '/telegram/link/$token',getParentRoute: () => rootRouteImport
          })
const AuthenticatedLexpractiqFirmsIndexRoute = AuthenticatedLexpractiqFirmsIndexRouteImport.update({
            id: '/lexpractiq/firms/',path: '/lexpractiq/firms/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedLexpractiqFirmsFirmIdRoute = AuthenticatedLexpractiqFirmsFirmIdRouteImport.update({
            id: '/lexpractiq/firms/$firmId',path: '/lexpractiq/firms/$firmId',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedLexpractiqMentorsIndexRoute = AuthenticatedLexpractiqMentorsIndexRouteImport.update({
            id: '/lexpractiq/mentors/',path: '/lexpractiq/mentors/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedLexpractiqMentorsApplyRoute = AuthenticatedLexpractiqMentorsApplyRouteImport.update({
            id: '/lexpractiq/mentors/apply',path: '/lexpractiq/mentors/apply',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedLexpractiqMentorsQAndARoute = AuthenticatedLexpractiqMentorsQAndARouteImport.update({
            id: '/lexpractiq/mentors/q-and-a',path: '/lexpractiq/mentors/q-and-a',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedLexpractiqMentorsSessionsRoute = AuthenticatedLexpractiqMentorsSessionsRouteImport.update({
            id: '/lexpractiq/mentors/sessions',path: '/lexpractiq/mentors/sessions',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedLexpractiqRecruiterAssessmentsRoute = AuthenticatedLexpractiqRecruiterAssessmentsRouteImport.update({
            id: '/assessments',path: '/assessments',getParentRoute: () => AuthenticatedLexpractiqRecruiterRoute
          })
const AuthenticatedPortalAcademyIndexRoute = AuthenticatedPortalAcademyIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedPortalAcademyRoute
          })
const AuthenticatedPortalAcademySlugRoute = AuthenticatedPortalAcademySlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => AuthenticatedPortalAcademyRoute
          })
const AuthenticatedPortalAdminAcademyRoute = AuthenticatedPortalAdminAcademyRouteImport.update({
            id: '/academy',path: '/academy',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminAcademyAiBuilderRoute = AuthenticatedPortalAdminAcademyAiBuilderRouteImport.update({
            id: '/academy-ai-builder',path: '/academy-ai-builder',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminAcademyQaRoute = AuthenticatedPortalAdminAcademyQaRouteImport.update({
            id: '/academy-qa',path: '/academy-qa',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminAccountingRoute = AuthenticatedPortalAdminAccountingRouteImport.update({
            id: '/accounting',path: '/accounting',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminAdsStudioRoute = AuthenticatedPortalAdminAdsStudioRouteImport.update({
            id: '/ads-studio',path: '/ads-studio',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminAiAssistantRoute = AuthenticatedPortalAdminAiAssistantRouteImport.update({
            id: '/ai-assistant',path: '/ai-assistant',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminAiStatusRoute = AuthenticatedPortalAdminAiStatusRouteImport.update({
            id: '/ai-status',path: '/ai-status',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminAllOrdersRoute = AuthenticatedPortalAdminAllOrdersRouteImport.update({
            id: '/all-orders',path: '/all-orders',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminAwarenessRoute = AuthenticatedPortalAdminAwarenessRouteImport.update({
            id: '/awareness',path: '/awareness',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminBookingsRoute = AuthenticatedPortalAdminBookingsRouteImport.update({
            id: '/bookings',path: '/bookings',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminBrandInstallmentsRoute = AuthenticatedPortalAdminBrandInstallmentsRouteImport.update({
            id: '/brand-installments',path: '/brand-installments',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminCanvaStudioRoute = AuthenticatedPortalAdminCanvaStudioRouteImport.update({
            id: '/canva-studio',path: '/canva-studio',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminCareersRoute = AuthenticatedPortalAdminCareersRouteImport.update({
            id: '/careers',path: '/careers',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminCertificatesRoute = AuthenticatedPortalAdminCertificatesRouteImport.update({
            id: '/certificates',path: '/certificates',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminClientBrandsRoute = AuthenticatedPortalAdminClientBrandsRouteImport.update({
            id: '/client-brands',path: '/client-brands',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminClientCreditsRoute = AuthenticatedPortalAdminClientCreditsRouteImport.update({
            id: '/client-credits',path: '/client-credits',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminClientsRoute = AuthenticatedPortalAdminClientsRouteImport.update({
            id: '/clients',path: '/clients',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminCompanyAssetsRoute = AuthenticatedPortalAdminCompanyAssetsRouteImport.update({
            id: '/company-assets',path: '/company-assets',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminComposeEmailRoute = AuthenticatedPortalAdminComposeEmailRouteImport.update({
            id: '/compose-email',path: '/compose-email',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminContractOrdersRoute = AuthenticatedPortalAdminContractOrdersRouteImport.update({
            id: '/contract-orders',path: '/contract-orders',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminCosecQuotesRoute = AuthenticatedPortalAdminCosecQuotesRouteImport.update({
            id: '/cosec-quotes',path: '/cosec-quotes',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminCreditOrdersRoute = AuthenticatedPortalAdminCreditOrdersRouteImport.update({
            id: '/credit-orders',path: '/credit-orders',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminCreditOrdersAuditRoute = AuthenticatedPortalAdminCreditOrdersAuditRouteImport.update({
            id: '/credit-orders-audit',path: '/credit-orders-audit',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminCreditReconciliationRoute = AuthenticatedPortalAdminCreditReconciliationRouteImport.update({
            id: '/credit-reconciliation',path: '/credit-reconciliation',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminCvRoute = AuthenticatedPortalAdminCvRouteImport.update({
            id: '/cv',path: '/cv',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminCvChecklistsRoute = AuthenticatedPortalAdminCvChecklistsRouteImport.update({
            id: '/cv-checklists',path: '/cv-checklists',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminCvOrdersRoute = AuthenticatedPortalAdminCvOrdersRouteImport.update({
            id: '/cv-orders',path: '/cv-orders',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminDiagnosticsRoute = AuthenticatedPortalAdminDiagnosticsRouteImport.update({
            id: '/diagnostics',path: '/diagnostics',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminDocumentsRoute = AuthenticatedPortalAdminDocumentsRouteImport.update({
            id: '/documents',path: '/documents',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminEnquiriesRoute = AuthenticatedPortalAdminEnquiriesRouteImport.update({
            id: '/enquiries',path: '/enquiries',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminInboxRoute = AuthenticatedPortalAdminInboxRouteImport.update({
            id: '/inbox',path: '/inbox',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminInvoiceEmailsRoute = AuthenticatedPortalAdminInvoiceEmailsRouteImport.update({
            id: '/invoice-emails',path: '/invoice-emails',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminInvoiceReconciliationRoute = AuthenticatedPortalAdminInvoiceReconciliationRouteImport.update({
            id: '/invoice-reconciliation',path: '/invoice-reconciliation',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminInvoiceReminderRunsRoute = AuthenticatedPortalAdminInvoiceReminderRunsRouteImport.update({
            id: '/invoice-reminder-runs',path: '/invoice-reminder-runs',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminInvoiceRemindersRoute = AuthenticatedPortalAdminInvoiceRemindersRouteImport.update({
            id: '/invoice-reminders',path: '/invoice-reminders',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminLabourAnalysesRoute = AuthenticatedPortalAdminLabourAnalysesRouteImport.update({
            id: '/labour-analyses',path: '/labour-analyses',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminLabourAnalysesAuditRoute = AuthenticatedPortalAdminLabourAnalysesAuditRouteImport.update({
            id: '/labour-analyses-audit',path: '/labour-analyses-audit',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminLabourTemplatesRoute = AuthenticatedPortalAdminLabourTemplatesRouteImport.update({
            id: '/labour-templates',path: '/labour-templates',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminLegalUpdatesRoute = AuthenticatedPortalAdminLegalUpdatesRouteImport.update({
            id: '/legal-updates',path: '/legal-updates',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminLibraryRoute = AuthenticatedPortalAdminLibraryRouteImport.update({
            id: '/library',path: '/library',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminLinkedinStudioRoute = AuthenticatedPortalAdminLinkedinStudioRouteImport.update({
            id: '/linkedin-studio',path: '/linkedin-studio',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminLlbEmailLogsRoute = AuthenticatedPortalAdminLlbEmailLogsRouteImport.update({
            id: '/llb-email-logs',path: '/llb-email-logs',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminLlbModulesRoute = AuthenticatedPortalAdminLlbModulesRouteImport.update({
            id: '/llb-modules',path: '/llb-modules',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminLlbNotesCacheRoute = AuthenticatedPortalAdminLlbNotesCacheRouteImport.update({
            id: '/llb-notes-cache',path: '/llb-notes-cache',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminLlbStoryVideosRoute = AuthenticatedPortalAdminLlbStoryVideosRouteImport.update({
            id: '/llb-story-videos',path: '/llb-story-videos',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminLlbTailoredNotesRoute = AuthenticatedPortalAdminLlbTailoredNotesRouteImport.update({
            id: '/llb-tailored-notes',path: '/llb-tailored-notes',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminLlbTutoringRoute = AuthenticatedPortalAdminLlbTutoringRouteImport.update({
            id: '/llb-tutoring',path: '/llb-tutoring',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminManualInvoicesRoute = AuthenticatedPortalAdminManualInvoicesRouteImport.update({
            id: '/manual-invoices',path: '/manual-invoices',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminNewsRoute = AuthenticatedPortalAdminNewsRouteImport.update({
            id: '/news',path: '/news',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminOutreachRoute = AuthenticatedPortalAdminOutreachRouteImport.update({
            id: '/outreach',path: '/outreach',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminPayfastInvoiceLogRoute = AuthenticatedPortalAdminPayfastInvoiceLogRouteImport.update({
            id: '/payfast-invoice-log',path: '/payfast-invoice-log',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminPayfastItnRoute = AuthenticatedPortalAdminPayfastItnRouteImport.update({
            id: '/payfast-itn',path: '/payfast-itn',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminPayfastWebhookRoute = AuthenticatedPortalAdminPayfastWebhookRouteImport.update({
            id: '/payfast-webhook',path: '/payfast-webhook',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminPaymentEventsRoute = AuthenticatedPortalAdminPaymentEventsRouteImport.update({
            id: '/payment-events',path: '/payment-events',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminPaymentsMonitorRoute = AuthenticatedPortalAdminPaymentsMonitorRouteImport.update({
            id: '/payments-monitor',path: '/payments-monitor',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminPresentationsRoute = AuthenticatedPortalAdminPresentationsRouteImport.update({
            id: '/presentations',path: '/presentations',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminProspectingRoute = AuthenticatedPortalAdminProspectingRouteImport.update({
            id: '/prospecting',path: '/prospecting',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminProspectiveLearnersRoute = AuthenticatedPortalAdminProspectiveLearnersRouteImport.update({
            id: '/prospective-learners',path: '/prospective-learners',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminRadioRoute = AuthenticatedPortalAdminRadioRouteImport.update({
            id: '/radio',path: '/radio',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminReceiptsQueueRoute = AuthenticatedPortalAdminReceiptsQueueRouteImport.update({
            id: '/receipts-queue',path: '/receipts-queue',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminResearchRoute = AuthenticatedPortalAdminResearchRouteImport.update({
            id: '/research',path: '/research',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminRssSourcesRoute = AuthenticatedPortalAdminRssSourcesRouteImport.update({
            id: '/rss-sources',path: '/rss-sources',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminSecurityRoute = AuthenticatedPortalAdminSecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminSecurityAlertsRoute = AuthenticatedPortalAdminSecurityAlertsRouteImport.update({
            id: '/security-alerts',path: '/security-alerts',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminSentEmailsRoute = AuthenticatedPortalAdminSentEmailsRouteImport.update({
            id: '/sent-emails',path: '/sent-emails',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminShareAttemptsRoute = AuthenticatedPortalAdminShareAttemptsRouteImport.update({
            id: '/share-attempts',path: '/share-attempts',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminSocialAnalyticsRoute = AuthenticatedPortalAdminSocialAnalyticsRouteImport.update({
            id: '/social-analytics',path: '/social-analytics',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminSocialQueueRoute = AuthenticatedPortalAdminSocialQueueRouteImport.update({
            id: '/social-queue',path: '/social-queue',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminSubscriptionsRoute = AuthenticatedPortalAdminSubscriptionsRouteImport.update({
            id: '/subscriptions',path: '/subscriptions',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminSupportTicketsRoute = AuthenticatedPortalAdminSupportTicketsRouteImport.update({
            id: '/support-tickets',path: '/support-tickets',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminTelegramRoute = AuthenticatedPortalAdminTelegramRouteImport.update({
            id: '/telegram',path: '/telegram',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminUsersRoute = AuthenticatedPortalAdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminVacancySourcesRoute = AuthenticatedPortalAdminVacancySourcesRouteImport.update({
            id: '/vacancy-sources',path: '/vacancy-sources',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminWritingAcademyRoute = AuthenticatedPortalAdminWritingAcademyRouteImport.update({
            id: '/writing-academy',path: '/writing-academy',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalLabourAnalyzerIdRoute = AuthenticatedPortalLabourAnalyzerIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedPortalLabourAnalyzerRoute
          })
const AuthenticatedPortalStudentIndexRoute = AuthenticatedPortalStudentIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedPortalStudentRoute
          })
const AuthenticatedPortalStudentAssignmentsRoute = AuthenticatedPortalStudentAssignmentsRouteImport.update({
            id: '/assignments',path: '/assignments',getParentRoute: () => AuthenticatedPortalStudentRoute
          })
const AuthenticatedPortalStudentPortfolioRoute = AuthenticatedPortalStudentPortfolioRouteImport.update({
            id: '/portfolio',path: '/portfolio',getParentRoute: () => AuthenticatedPortalStudentRoute
          })
const AuthenticatedPortalStudentProfileRoute = AuthenticatedPortalStudentProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AuthenticatedPortalStudentRoute
          })
const AuthenticatedPortalStudentWorkspaceRoute = AuthenticatedPortalStudentWorkspaceRouteImport.update({
            id: '/workspace',path: '/workspace',getParentRoute: () => AuthenticatedPortalStudentRoute
          })
const AuthenticatedPortalWritingAcademySlugRoute = AuthenticatedPortalWritingAcademySlugRouteImport.update({
            id: '/writing-academy/$slug',path: '/writing-academy/$slug',getParentRoute: () => AuthenticatedPortalRoute
          })
const ContractsSlugOrderTokenRoute = ContractsSlugOrderTokenRouteImport.update({
            id: '/order/$token',path: '/order/$token',getParentRoute: () => ContractsSlugRoute
          })
const AuthenticatedLexpractiqFirmsFirmIdDashboardRoute = AuthenticatedLexpractiqFirmsFirmIdDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedLexpractiqFirmsFirmIdRoute
          })
const AuthenticatedLexpractiqFirmsAssignmentIdRoute = AuthenticatedLexpractiqFirmsAssignmentIdRouteImport.update({
            id: '/lexpractiq/firms/assignment/$id',path: '/lexpractiq/firms/assignment/$id',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedLexpractiqSimulationsSlugRunRoute = AuthenticatedLexpractiqSimulationsSlugRunRouteImport.update({
            id: '/lexpractiq/simulations/$slug/run',path: '/lexpractiq/simulations/$slug/run',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPortalAdminCasesIndexRoute = AuthenticatedPortalAdminCasesIndexRouteImport.update({
            id: '/cases/',path: '/cases/',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminCasesIdRoute = AuthenticatedPortalAdminCasesIdRouteImport.update({
            id: '/cases/$id',path: '/cases/$id',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminCasesNewRoute = AuthenticatedPortalAdminCasesNewRouteImport.update({
            id: '/cases/new',path: '/cases/new',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminCasesReportsRoute = AuthenticatedPortalAdminCasesReportsRouteImport.update({
            id: '/cases/reports',path: '/cases/reports',getParentRoute: () => AuthenticatedPortalAdminRoute
          })
const AuthenticatedPortalAdminLabourAnalysesIdRoute = AuthenticatedPortalAdminLabourAnalysesIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedPortalAdminLabourAnalysesRoute
          })
const AuthenticatedPortalAdminLabourTemplatesIdRoute = AuthenticatedPortalAdminLabourTemplatesIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedPortalAdminLabourTemplatesRoute
          })
const AuthenticatedPortalAdminLabourTemplatesNewRoute = AuthenticatedPortalAdminLabourTemplatesNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AuthenticatedPortalAdminLabourTemplatesRoute
          })
const AuthenticatedPortalAdminManualInvoicesIdRoute = AuthenticatedPortalAdminManualInvoicesIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedPortalAdminManualInvoicesRoute
          })
const AuthenticatedPortalLabourAnalyzerIdForm711Route = AuthenticatedPortalLabourAnalyzerIdForm711RouteImport.update({
            id: '/form-7-11',path: '/form-7-11',getParentRoute: () => AuthenticatedPortalLabourAnalyzerIdRoute
          })





const AuthenticatedPortalAcademyRouteChildren = {
  AuthenticatedPortalAcademySlugRoute: AuthenticatedPortalAcademySlugRoute,AuthenticatedPortalAcademyIndexRoute: AuthenticatedPortalAcademyIndexRoute
}

const AuthenticatedPortalAcademyRouteWithChildren = AuthenticatedPortalAcademyRoute._addFileChildren(AuthenticatedPortalAcademyRouteChildren)




const AuthenticatedPortalAdminLabourAnalysesRouteChildren = {
  AuthenticatedPortalAdminLabourAnalysesIdRoute: AuthenticatedPortalAdminLabourAnalysesIdRoute
}

const AuthenticatedPortalAdminLabourAnalysesRouteWithChildren = AuthenticatedPortalAdminLabourAnalysesRoute._addFileChildren(AuthenticatedPortalAdminLabourAnalysesRouteChildren)




const AuthenticatedPortalAdminLabourTemplatesRouteChildren = {
  AuthenticatedPortalAdminLabourTemplatesIdRoute: AuthenticatedPortalAdminLabourTemplatesIdRoute,AuthenticatedPortalAdminLabourTemplatesNewRoute: AuthenticatedPortalAdminLabourTemplatesNewRoute
}

const AuthenticatedPortalAdminLabourTemplatesRouteWithChildren = AuthenticatedPortalAdminLabourTemplatesRoute._addFileChildren(AuthenticatedPortalAdminLabourTemplatesRouteChildren)




const AuthenticatedPortalAdminManualInvoicesRouteChildren = {
  AuthenticatedPortalAdminManualInvoicesIdRoute: AuthenticatedPortalAdminManualInvoicesIdRoute
}

const AuthenticatedPortalAdminManualInvoicesRouteWithChildren = AuthenticatedPortalAdminManualInvoicesRoute._addFileChildren(AuthenticatedPortalAdminManualInvoicesRouteChildren)



const AuthenticatedPortalAdminRouteChildren = {
  AuthenticatedPortalAdminAcademyRoute: AuthenticatedPortalAdminAcademyRoute,AuthenticatedPortalAdminAcademyAiBuilderRoute: AuthenticatedPortalAdminAcademyAiBuilderRoute,AuthenticatedPortalAdminAcademyQaRoute: AuthenticatedPortalAdminAcademyQaRoute,AuthenticatedPortalAdminAccountingRoute: AuthenticatedPortalAdminAccountingRoute,AuthenticatedPortalAdminAdsStudioRoute: AuthenticatedPortalAdminAdsStudioRoute,AuthenticatedPortalAdminAiAssistantRoute: AuthenticatedPortalAdminAiAssistantRoute,AuthenticatedPortalAdminAiStatusRoute: AuthenticatedPortalAdminAiStatusRoute,AuthenticatedPortalAdminAllOrdersRoute: AuthenticatedPortalAdminAllOrdersRoute,AuthenticatedPortalAdminAwarenessRoute: AuthenticatedPortalAdminAwarenessRoute,AuthenticatedPortalAdminBookingsRoute: AuthenticatedPortalAdminBookingsRoute,AuthenticatedPortalAdminBrandInstallmentsRoute: AuthenticatedPortalAdminBrandInstallmentsRoute,AuthenticatedPortalAdminCanvaStudioRoute: AuthenticatedPortalAdminCanvaStudioRoute,AuthenticatedPortalAdminCareersRoute: AuthenticatedPortalAdminCareersRoute,AuthenticatedPortalAdminCertificatesRoute: AuthenticatedPortalAdminCertificatesRoute,AuthenticatedPortalAdminClientBrandsRoute: AuthenticatedPortalAdminClientBrandsRoute,AuthenticatedPortalAdminClientCreditsRoute: AuthenticatedPortalAdminClientCreditsRoute,AuthenticatedPortalAdminClientsRoute: AuthenticatedPortalAdminClientsRoute,AuthenticatedPortalAdminCompanyAssetsRoute: AuthenticatedPortalAdminCompanyAssetsRoute,AuthenticatedPortalAdminComposeEmailRoute: AuthenticatedPortalAdminComposeEmailRoute,AuthenticatedPortalAdminContractOrdersRoute: AuthenticatedPortalAdminContractOrdersRoute,AuthenticatedPortalAdminCosecQuotesRoute: AuthenticatedPortalAdminCosecQuotesRoute,AuthenticatedPortalAdminCreditOrdersRoute: AuthenticatedPortalAdminCreditOrdersRoute,AuthenticatedPortalAdminCreditOrdersAuditRoute: AuthenticatedPortalAdminCreditOrdersAuditRoute,AuthenticatedPortalAdminCreditReconciliationRoute: AuthenticatedPortalAdminCreditReconciliationRoute,AuthenticatedPortalAdminCvRoute: AuthenticatedPortalAdminCvRoute,AuthenticatedPortalAdminCvChecklistsRoute: AuthenticatedPortalAdminCvChecklistsRoute,AuthenticatedPortalAdminCvOrdersRoute: AuthenticatedPortalAdminCvOrdersRoute,AuthenticatedPortalAdminDiagnosticsRoute: AuthenticatedPortalAdminDiagnosticsRoute,AuthenticatedPortalAdminDocumentsRoute: AuthenticatedPortalAdminDocumentsRoute,AuthenticatedPortalAdminEnquiriesRoute: AuthenticatedPortalAdminEnquiriesRoute,AuthenticatedPortalAdminInboxRoute: AuthenticatedPortalAdminInboxRoute,AuthenticatedPortalAdminInvoiceEmailsRoute: AuthenticatedPortalAdminInvoiceEmailsRoute,AuthenticatedPortalAdminInvoiceReconciliationRoute: AuthenticatedPortalAdminInvoiceReconciliationRoute,AuthenticatedPortalAdminInvoiceReminderRunsRoute: AuthenticatedPortalAdminInvoiceReminderRunsRoute,AuthenticatedPortalAdminInvoiceRemindersRoute: AuthenticatedPortalAdminInvoiceRemindersRoute,AuthenticatedPortalAdminLabourAnalysesRoute: AuthenticatedPortalAdminLabourAnalysesRouteWithChildren,AuthenticatedPortalAdminLabourAnalysesAuditRoute: AuthenticatedPortalAdminLabourAnalysesAuditRoute,AuthenticatedPortalAdminLabourTemplatesRoute: AuthenticatedPortalAdminLabourTemplatesRouteWithChildren,AuthenticatedPortalAdminLegalUpdatesRoute: AuthenticatedPortalAdminLegalUpdatesRoute,AuthenticatedPortalAdminLibraryRoute: AuthenticatedPortalAdminLibraryRoute,AuthenticatedPortalAdminLinkedinStudioRoute: AuthenticatedPortalAdminLinkedinStudioRoute,AuthenticatedPortalAdminLlbEmailLogsRoute: AuthenticatedPortalAdminLlbEmailLogsRoute,AuthenticatedPortalAdminLlbModulesRoute: AuthenticatedPortalAdminLlbModulesRoute,AuthenticatedPortalAdminLlbNotesCacheRoute: AuthenticatedPortalAdminLlbNotesCacheRoute,AuthenticatedPortalAdminLlbStoryVideosRoute: AuthenticatedPortalAdminLlbStoryVideosRoute,AuthenticatedPortalAdminLlbTailoredNotesRoute: AuthenticatedPortalAdminLlbTailoredNotesRoute,AuthenticatedPortalAdminLlbTutoringRoute: AuthenticatedPortalAdminLlbTutoringRoute,AuthenticatedPortalAdminManualInvoicesRoute: AuthenticatedPortalAdminManualInvoicesRouteWithChildren,AuthenticatedPortalAdminNewsRoute: AuthenticatedPortalAdminNewsRoute,AuthenticatedPortalAdminOutreachRoute: AuthenticatedPortalAdminOutreachRoute,AuthenticatedPortalAdminPayfastInvoiceLogRoute: AuthenticatedPortalAdminPayfastInvoiceLogRoute,AuthenticatedPortalAdminPayfastItnRoute: AuthenticatedPortalAdminPayfastItnRoute,AuthenticatedPortalAdminPayfastWebhookRoute: AuthenticatedPortalAdminPayfastWebhookRoute,AuthenticatedPortalAdminPaymentEventsRoute: AuthenticatedPortalAdminPaymentEventsRoute,AuthenticatedPortalAdminPaymentsMonitorRoute: AuthenticatedPortalAdminPaymentsMonitorRoute,AuthenticatedPortalAdminPresentationsRoute: AuthenticatedPortalAdminPresentationsRoute,AuthenticatedPortalAdminProspectingRoute: AuthenticatedPortalAdminProspectingRoute,AuthenticatedPortalAdminProspectiveLearnersRoute: AuthenticatedPortalAdminProspectiveLearnersRoute,AuthenticatedPortalAdminRadioRoute: AuthenticatedPortalAdminRadioRoute,AuthenticatedPortalAdminReceiptsQueueRoute: AuthenticatedPortalAdminReceiptsQueueRoute,AuthenticatedPortalAdminResearchRoute: AuthenticatedPortalAdminResearchRoute,AuthenticatedPortalAdminRssSourcesRoute: AuthenticatedPortalAdminRssSourcesRoute,AuthenticatedPortalAdminSecurityRoute: AuthenticatedPortalAdminSecurityRoute,AuthenticatedPortalAdminSecurityAlertsRoute: AuthenticatedPortalAdminSecurityAlertsRoute,AuthenticatedPortalAdminSentEmailsRoute: AuthenticatedPortalAdminSentEmailsRoute,AuthenticatedPortalAdminShareAttemptsRoute: AuthenticatedPortalAdminShareAttemptsRoute,AuthenticatedPortalAdminSocialAnalyticsRoute: AuthenticatedPortalAdminSocialAnalyticsRoute,AuthenticatedPortalAdminSocialQueueRoute: AuthenticatedPortalAdminSocialQueueRoute,AuthenticatedPortalAdminSubscriptionsRoute: AuthenticatedPortalAdminSubscriptionsRoute,AuthenticatedPortalAdminSupportTicketsRoute: AuthenticatedPortalAdminSupportTicketsRoute,AuthenticatedPortalAdminTelegramRoute: AuthenticatedPortalAdminTelegramRoute,AuthenticatedPortalAdminUsersRoute: AuthenticatedPortalAdminUsersRoute,AuthenticatedPortalAdminVacancySourcesRoute: AuthenticatedPortalAdminVacancySourcesRoute,AuthenticatedPortalAdminWritingAcademyRoute: AuthenticatedPortalAdminWritingAcademyRoute,AuthenticatedPortalAdminCasesIdRoute: AuthenticatedPortalAdminCasesIdRoute,AuthenticatedPortalAdminCasesNewRoute: AuthenticatedPortalAdminCasesNewRoute,AuthenticatedPortalAdminCasesReportsRoute: AuthenticatedPortalAdminCasesReportsRoute,AuthenticatedPortalAdminCasesIndexRoute: AuthenticatedPortalAdminCasesIndexRoute
}

const AuthenticatedPortalAdminRouteWithChildren = AuthenticatedPortalAdminRoute._addFileChildren(AuthenticatedPortalAdminRouteChildren)




const AuthenticatedPortalLabourAnalyzerIdRouteChildren = {
  AuthenticatedPortalLabourAnalyzerIdForm711Route: AuthenticatedPortalLabourAnalyzerIdForm711Route
}

const AuthenticatedPortalLabourAnalyzerIdRouteWithChildren = AuthenticatedPortalLabourAnalyzerIdRoute._addFileChildren(AuthenticatedPortalLabourAnalyzerIdRouteChildren)



const AuthenticatedPortalLabourAnalyzerRouteChildren = {
  AuthenticatedPortalLabourAnalyzerIdRoute: AuthenticatedPortalLabourAnalyzerIdRouteWithChildren
}

const AuthenticatedPortalLabourAnalyzerRouteWithChildren = AuthenticatedPortalLabourAnalyzerRoute._addFileChildren(AuthenticatedPortalLabourAnalyzerRouteChildren)




const AuthenticatedPortalStudentRouteChildren = {
  AuthenticatedPortalStudentAssignmentsRoute: AuthenticatedPortalStudentAssignmentsRoute,AuthenticatedPortalStudentPortfolioRoute: AuthenticatedPortalStudentPortfolioRoute,AuthenticatedPortalStudentProfileRoute: AuthenticatedPortalStudentProfileRoute,AuthenticatedPortalStudentWorkspaceRoute: AuthenticatedPortalStudentWorkspaceRoute,AuthenticatedPortalStudentIndexRoute: AuthenticatedPortalStudentIndexRoute
}

const AuthenticatedPortalStudentRouteWithChildren = AuthenticatedPortalStudentRoute._addFileChildren(AuthenticatedPortalStudentRouteChildren)



const AuthenticatedPortalRouteChildren = {
  AuthenticatedPortalAcademyRoute: AuthenticatedPortalAcademyRouteWithChildren,AuthenticatedPortalAccountRoute: AuthenticatedPortalAccountRoute,AuthenticatedPortalAdminRoute: AuthenticatedPortalAdminRouteWithChildren,AuthenticatedPortalCertificatesRoute: AuthenticatedPortalCertificatesRoute,AuthenticatedPortalChatRoute: AuthenticatedPortalChatRoute,AuthenticatedPortalCreditsRoute: AuthenticatedPortalCreditsRoute,AuthenticatedPortalCvRoute: AuthenticatedPortalCvRoute,AuthenticatedPortalDashboardRoute: AuthenticatedPortalDashboardRoute,AuthenticatedPortalDocumentsRoute: AuthenticatedPortalDocumentsRoute,AuthenticatedPortalInterviewRoute: AuthenticatedPortalInterviewRoute,AuthenticatedPortalInvoicesRoute: AuthenticatedPortalInvoicesRoute,AuthenticatedPortalJobMatchesRoute: AuthenticatedPortalJobMatchesRoute,AuthenticatedPortalLabourAnalyzerRoute: AuthenticatedPortalLabourAnalyzerRouteWithChildren,AuthenticatedPortalLlbReceiptsRoute: AuthenticatedPortalLlbReceiptsRoute,AuthenticatedPortalLlbTutoringRoute: AuthenticatedPortalLlbTutoringRoute,AuthenticatedPortalMattersRoute: AuthenticatedPortalMattersRoute,AuthenticatedPortalMyCitationsRoute: AuthenticatedPortalMyCitationsRoute,AuthenticatedPortalMyPaymentsRoute: AuthenticatedPortalMyPaymentsRoute,AuthenticatedPortalOrdersRoute: AuthenticatedPortalOrdersRoute,AuthenticatedPortalProfileRoute: AuthenticatedPortalProfileRoute,AuthenticatedPortalStudentRoute: AuthenticatedPortalStudentRouteWithChildren,AuthenticatedPortalSubscriptionRoute: AuthenticatedPortalSubscriptionRoute,AuthenticatedPortalToolsDashboardRoute: AuthenticatedPortalToolsDashboardRoute,AuthenticatedPortalIndexRoute: AuthenticatedPortalIndexRoute,AuthenticatedPortalWritingAcademySlugRoute: AuthenticatedPortalWritingAcademySlugRoute
}

const AuthenticatedPortalRouteWithChildren = AuthenticatedPortalRoute._addFileChildren(AuthenticatedPortalRouteChildren)




const AuthenticatedLexpractiqRecruiterRouteChildren = {
  AuthenticatedLexpractiqRecruiterAssessmentsRoute: AuthenticatedLexpractiqRecruiterAssessmentsRoute
}

const AuthenticatedLexpractiqRecruiterRouteWithChildren = AuthenticatedLexpractiqRecruiterRoute._addFileChildren(AuthenticatedLexpractiqRecruiterRouteChildren)




const AuthenticatedLexpractiqFirmsFirmIdRouteChildren = {
  AuthenticatedLexpractiqFirmsFirmIdDashboardRoute: AuthenticatedLexpractiqFirmsFirmIdDashboardRoute
}

const AuthenticatedLexpractiqFirmsFirmIdRouteWithChildren = AuthenticatedLexpractiqFirmsFirmIdRoute._addFileChildren(AuthenticatedLexpractiqFirmsFirmIdRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedPortalRoute: AuthenticatedPortalRouteWithChildren,AuthenticatedLexpractiqDashboardRoute: AuthenticatedLexpractiqDashboardRoute,AuthenticatedLexpractiqMyAssessmentsRoute: AuthenticatedLexpractiqMyAssessmentsRoute,AuthenticatedLexpractiqPortfolioEvidenceRoute: AuthenticatedLexpractiqPortfolioEvidenceRoute,AuthenticatedLexpractiqRecruiterRoute: AuthenticatedLexpractiqRecruiterRouteWithChildren,AuthenticatedLexpractiqUniversityRoute: AuthenticatedLexpractiqUniversityRoute,AuthenticatedLexpractiqFirmsFirmIdRoute: AuthenticatedLexpractiqFirmsFirmIdRouteWithChildren,AuthenticatedLexpractiqMentorsApplyRoute: AuthenticatedLexpractiqMentorsApplyRoute,AuthenticatedLexpractiqMentorsQAndARoute: AuthenticatedLexpractiqMentorsQAndARoute,AuthenticatedLexpractiqMentorsSessionsRoute: AuthenticatedLexpractiqMentorsSessionsRoute,AuthenticatedLexpractiqFirmsIndexRoute: AuthenticatedLexpractiqFirmsIndexRoute,AuthenticatedLexpractiqMentorsIndexRoute: AuthenticatedLexpractiqMentorsIndexRoute,AuthenticatedLexpractiqFirmsAssignmentIdRoute: AuthenticatedLexpractiqFirmsAssignmentIdRoute,AuthenticatedLexpractiqSimulationsSlugRunRoute: AuthenticatedLexpractiqSimulationsSlugRunRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const CareersRouteChildren = {
  CareersIdRoute: CareersIdRoute,CareersUnsubscribeRoute: CareersUnsubscribeRoute,CareersSubscribeConfirmRoute: CareersSubscribeConfirmRoute
}

const CareersRouteWithChildren = CareersRoute._addFileChildren(CareersRouteChildren)




const ContractsSlugRouteChildren = {
  ContractsSlugOrderTokenRoute: ContractsSlugOrderTokenRoute
}

const ContractsSlugRouteWithChildren = ContractsSlugRoute._addFileChildren(ContractsSlugRouteChildren)



const ContractsRouteChildren = {
  ContractsSlugRoute: ContractsSlugRouteWithChildren
}

const ContractsRouteWithChildren = ContractsRoute._addFileChildren(ContractsRouteChildren)




const EducationResearchRouteChildren = {
  EducationResearchAssignmentRoute: EducationResearchAssignmentRoute,EducationResearchCaseAnalysisRoute: EducationResearchCaseAnalysisRoute,EducationResearchFootnotesRoute: EducationResearchFootnotesRoute,EducationResearchIracRoute: EducationResearchIracRoute,EducationResearchJudgmentSummaryRoute: EducationResearchJudgmentSummaryRoute,EducationResearchSourcesRoute: EducationResearchSourcesRoute,EducationResearchTemplatesRoute: EducationResearchTemplatesRoute,EducationResearchWorksheetRoute: EducationResearchWorksheetRoute,EducationResearchIndexRoute: EducationResearchIndexRoute
}

const EducationResearchRouteWithChildren = EducationResearchRoute._addFileChildren(EducationResearchRouteChildren)




const EducationWritingRouteChildren = {
  EducationWritingStyleRoute: EducationWritingStyleRoute,EducationWritingArticleEditorRoute: EducationWritingArticleEditorRoute,EducationWritingBibliographyRoute: EducationWritingBibliographyRoute,EducationWritingTemplatesRoute: EducationWritingTemplatesRoute,EducationWritingToolsRoute: EducationWritingToolsRoute,EducationWritingIndexRoute: EducationWritingIndexRoute
}

const EducationWritingRouteWithChildren = EducationWritingRoute._addFileChildren(EducationWritingRouteChildren)



const EducationRouteChildren = {
  EducationCourtOnlineRoute: EducationCourtOnlineRoute,EducationHighSchoolRoute: EducationHighSchoolRoute,EducationLegalArticleGuideRoute: EducationLegalArticleGuideRoute,EducationLlbTutoringRoute: EducationLlbTutoringRoute,EducationResearchRoute: EducationResearchRouteWithChildren,EducationWritingRoute: EducationWritingRouteWithChildren,EducationIndexRoute: EducationIndexRoute,EducationSkillsSlugRoute: EducationSkillsSlugRoute
}

const EducationRouteWithChildren = EducationRoute._addFileChildren(EducationRouteChildren)




const GuidesRouteChildren = {
  GuidesSlugRoute: GuidesSlugRoute
}

const GuidesRouteWithChildren = GuidesRoute._addFileChildren(GuidesRouteChildren)




const LegislationRouteChildren = {
  LegislationSlugRoute: LegislationSlugRoute
}

const LegislationRouteWithChildren = LegislationRoute._addFileChildren(LegislationRouteChildren)




const LexpractiqRouteChildren = {
  LexpractiqForEmployersRoute: LexpractiqForEmployersRoute,LexpractiqForUniversitiesRoute: LexpractiqForUniversitiesRoute,LexpractiqHowItWorksRoute: LexpractiqHowItWorksRoute,LexpractiqIndexRoute: LexpractiqIndexRoute,LexpractiqPortfolioUserIdRoute: LexpractiqPortfolioUserIdRoute,LexpractiqSimulationsSlugRoute: LexpractiqSimulationsSlugRoute,LexpractiqVerifyTokenRoute: LexpractiqVerifyTokenRoute,LexpractiqSimulationsIndexRoute: LexpractiqSimulationsIndexRoute
}

const LexpractiqRouteWithChildren = LexpractiqRoute._addFileChildren(LexpractiqRouteChildren)




const NewsRouteChildren = {
  NewsSlugRoute: NewsSlugRoute
}

const NewsRouteWithChildren = NewsRoute._addFileChildren(NewsRouteChildren)




const RadioRouteChildren = {
  RadioSlugRoute: RadioSlugRoute
}

const RadioRouteWithChildren = RadioRoute._addFileChildren(RadioRouteChildren)




const ResourcesRouteChildren = {
  ResourcesSlugRoute: ResourcesSlugRoute,ResourcesIndexRoute: ResourcesIndexRoute
}

const ResourcesRouteWithChildren = ResourcesRoute._addFileChildren(ResourcesRouteChildren)




const ServicesRouteChildren = {
  ServicesSlugRoute: ServicesSlugRoute,ServicesCompanySecretarialRoute: ServicesCompanySecretarialRoute,ServicesIndexRoute: ServicesIndexRoute
}

const ServicesRouteWithChildren = ServicesRoute._addFileChildren(ServicesRouteChildren)




const ToolsRouteChildren = {
  ToolsHumaniserRoute: ToolsHumaniserRoute,ToolsOcrRoute: ToolsOcrRoute,ToolsParaphraserRoute: ToolsParaphraserRoute,ToolsPdfRoute: ToolsPdfRoute,ToolsIndexRoute: ToolsIndexRoute
}

const ToolsRouteWithChildren = ToolsRoute._addFileChildren(ToolsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AboutRoute: AboutRoute,AttorneysRoute: AttorneysRoute,AuthRoute: AuthRoute,BookRoute: BookRoute,CareersRoute: CareersRouteWithChildren,CartRoute: CartRoute,CaseStudiesRoute: CaseStudiesRoute,CheckoutRoute: CheckoutRoute,ComplaintsRoute: ComplaintsRoute,ComplianceServicesRoute: ComplianceServicesRoute,ContactRoute: ContactRoute,ContractsRoute: ContractsRouteWithChildren,CorporateTrainingRoute: CorporateTrainingRoute,CreditsRoute: CreditsRoute,CrimeAwarenessRoute: CrimeAwarenessRoute,CvBuilderRoute: CvBuilderRoute,CvServicesRoute: CvServicesRoute,DailyLegalRoute: DailyLegalRoute,DisclaimerRoute: DisclaimerRoute,EducationRoute: EducationRouteWithChildren,EftPendingRoute: EftPendingRoute,FaqRoute: FaqRoute,FoundingPartnersRoute: FoundingPartnersRoute,GuidesRoute: GuidesRouteWithChildren,LegislationRoute: LegislationRouteWithChildren,LexpractiqRoute: LexpractiqRouteWithChildren,NewsRoute: NewsRouteWithChildren,PopiaRoute: PopiaRoute,PrivacyRoute: PrivacyRoute,RadioRoute: RadioRouteWithChildren,ResetPasswordRoute: ResetPasswordRoute,ResourcesRoute: ResourcesRouteWithChildren,ServicesRoute: ServicesRouteWithChildren,TermsRoute: TermsRoute,ToolsRoute: ToolsRouteWithChildren,UnsubscribeRoute: UnsubscribeRoute,VerifyRoute: VerifyRoute,WritingAcademyRoute: WritingAcademyRoute,DocumentServicesServiceIdRoute: DocumentServicesServiceIdRoute,InstallmentsRefRoute: InstallmentsRefRoute,InvoiceIdRoute: InvoiceIdRoute,InvoiceRefRoute: InvoiceRefRoute,LearnersJoinRoute: LearnersJoinRoute,LegalHelpTopicRoute: LegalHelpTopicRoute,OrderSuccessRefRoute: OrderSuccessRefRoute,PaymentStatusRefRoute: PaymentStatusRefRoute,PresentationsSlugRoute: PresentationsSlugRoute,DocumentServicesIndexRoute: DocumentServicesIndexRoute,InvoiceIndexRoute: InvoiceIndexRoute,PresentationsIndexRoute: PresentationsIndexRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute,PayInvoiceRefRoute: PayInvoiceRefRoute,TelegramLinkTokenRoute: TelegramLinkTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)